module.exports = __webpack_public_path__ + "img/bathroom.d4f978e7.svg";